<template>
    <div class="footer">
        <div class="container">
            <div class="row">
                <div class="content">
                    <div class="item contect">
                        <div class="row-1">
                            <img src="../assets/img/icon_phone_home_default.png" alt="" />
                            <span class="hotLine">服务热线</span>
                        </div>
                        <div class="row-2">020-22008988</div>
                    </div>
                    <div class="item mini serve">
                        <div class="title">我们的服务</div>
                        <div class="list">
                            <li>
                                <router-link to="/dataserve/dataInsight">数据洞察</router-link>
                            </li>
                            <li>
                                <router-link to="/dataserve/collateral">房屋智能估价</router-link>
                            </li>
                            <li>
                                <router-link to="/dataserve/viewitems">一键看项目</router-link>
                            </li>
                            <li>
                                <router-link to="/dataserve/customization">定制化</router-link>
                            </li>
                            <!-- <li>
                            <router-link to="/dataserve/exchange">交易所</router-link>
                        </li> -->
                        </div>
                    </div>
                    <div class="item mini data noshow">
                        <div class="title">数据洞察</div>
                        <div class="list">
                            <li>
                                <router-link to="/SeeBI/economic">宏观经济</router-link>
                            </li>
                            <li>
                                <router-link to="/SeeBI/land">土地市场</router-link>
                            </li>
                            <li>
                                <router-link to="/SeeBI/financial">金融市场</router-link>
                            </li>
                            <li>
                                <router-link to="/SeeBI/city">城市系统</router-link>
                            </li>
                            <li>
                                <router-link to="/SeeBI/enterprise">企业监测</router-link>
                            </li>
                            <li>
                                <router-link to="">舆情监测</router-link>
                            </li>
                        </div>
                    </div>
                    <div class="item mini about">
                        <div class="title">关于我们</div>
                        <div class="list">
                            <li>
                                <router-link to="/About#intro">简介</router-link>
                            </li>
                            <li>
                                <router-link to="/About#video">视频</router-link>
                            </li>
                            <li>
                                <router-link to="/About#contact">联系我们</router-link>
                            </li>
                            <li>
                                <router-link to="/JoinUs">招贤纳士</router-link>
                            </li>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="link">
                    <li>友情链接：</li>
                    <li>
                        <a class="link" target="_blank" href="http://www.zhongdihui.com/zdh/index.html">中地会</a>

                    </li>
                    <li>
                        <a class="link" target="_blank" href="https://www.ndrc.gov.cn/">国家发展和改革委员会</a>

                    </li>
                    <li>
                        <a class="link" target="_blank" href="https://data.stats.gov.cn/">国家数据局</a>

                    </li>
                    <li>
                        <a class="link" target="_blank"
                            href="https://www.cbirc.gov.cn/cn/view/pages/index/index.html">国家金融监督管理总局</a>

                    </li>
                    <li>
                        <a class="link" target="_blank" href="http://www.pbc.gov.cn/">人民银行</a>

                    </li>
                    <li>
                        <a class="link" target="_blank" href="https://www.most.gov.cn/index.html">国家科学技术部</a>

                    </li>
                    <!-- <li>
                    <a href="https://www.creprice.cn/">中国房价行情</a>
                </li> -->
                </div>
                <div class="copyRight">
                    <p>
                        Copyright 中思拓研究院所有
                        <span>
                            <a href="http://beian.miit.gov.cn/">粤ICP备19151020号</a>
                        </span>
                        <span>
                            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602007899">粤公网安备
                                44010602007899</a>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';

.footer {
    background-color: #263E8C;

    .content {
        font-size: 0;

        .item {
            @include inline-block;
            height: 350px;
            width: 380px;

            &.mini {
                width: 300px;
                margin-left: 60px;
            }
        }

        .contect {
            .row-1 {
                font-size: 0;
                margin: 97px auto 22px;

                img {
                    margin-left: 99px;
                    vertical-align: middle;
                }

                span {
                    @include default-text;
                    width: 72px;
                    height: 18px;
                    font-size: 18px;
                    vertical-align: middle;
                    margin-left: 35px;
                }
            }

            .row-2 {
                @include default-text;
                text-align: center;
                height: 24px;
                font-size: 30px;
            }
        }

        .mini {
            .title {
                @include default-text;
                width: 100px;
                font-size: 18px;
                margin: 72px auto 20px;
                border-bottom: 1px solid white;
                padding-bottom: 15px;
            }

            .list {
                margin-left: 100px;

                li {
                    margin-bottom: 13px;

                    a {
                        @include default-text;
                        height: 15px;
                        font-size: 14px;
                    }
                }
            }
        }

        .noshow {
            display: none;
        }
    }

    .link {
        width: 810px;
        position: relative;
        left: 50%;
        transform: translate(-50%);
        margin-top: 30px;

        li {
            @include default-text;
            font-size: 14px;
            display: inline-block;
            margin-left: 14px;

            a {
                @include default-text;
                font-size: 14px;
            }
        }
    }

    .copyRight {
        font-size: 14px;
        height: 25px;
        text-align: center;
        margin-top: 17px;
        color: #697284;

        a {
            @include default-text;
            color: #697284;
        }
    }
}
</style>
